module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Bold.8e9f7083.ttf";